define('views/modules/attachment/attachment-list-item',[
    // Libs
    'jquery', 'underscore', 'backbone', 'mustache', 'utils', 'toastr',
    // templates
    'text!templates/modules/attachment/attachment-list-item.html',
], function(
    // Libs
    $, _, Backbone, Mustache, U, Toastr,
    // templates
    TAttachmentListItem
) {

    var VAttachmentListItem = Backbone.Epoxy.View.extend({
        template: TAttachmentListItem,
        events: {
            "click .remove-file": "onRemoveFile"
        },

        initialize: function(opt) {
            this.options = opt || {};
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext({
                // Messages use attachments plural but Notes use attachment in singular
                // Would be nice to fix eventually to make it consistent but it's annoying
                filename: this.options.model.get('attachments') && this.options.model.get('attachments').name ||
                    this.options.model.get('attachment').name
            })));

            return this;
        },

        // There is a event listener in chatbox to hide the attachment container when the collection is empty
        onRemoveFile: function() {
            this.options.model.collection.remove(this.model);
            this.$el.remove();
        }
    });

    return VAttachmentListItem;
});

